<template>
  <div 
    class="__card" 
    :class="fullWidth ? 'full-width' : ''"
    @click="clickEvent($event)"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    clickEvent(event) {
      if (!this.disabled) {
        this.$emit("click", event);
      } else {
        return;
      }
    },
  },
};
</script>


<style lang="scss">
.__card {
  width: 100%;
  max-width: 960px;

  margin: auto;
  max-width: 960px;
  background: #ffffff;
  box-shadow: 0px 0px 12px -4px rgba(0, 0, 0, 0.08),
    0px 8px 12px -8px rgba(0, 0, 0, 0.16);
  border-radius: 8px;

  display: flex;
  flex-direction: column !important;
  align-items: flex-start;
  padding: 24px;
  > *:not(:first-child) {
    margin-top: 24px;
  }
  &:not(:first-child) {
    margin-top: 24px;
  }
}
@media only screen and (max-width: 1900px) {
  .full-width {
    max-width: 1550px;
  }
}

@media only screen and (max-width: 1800px) {
  .full-width {
    max-width: 1450px;
  }
}

@media only screen and (max-width: 1700px) {
  .full-width {
    max-width: 1350px;
  }
}

@media only screen and (max-width: 1600px) {
  .full-width {
    max-width: 1220px;
  }
}

@media only screen and (max-width: 1500px) {
  .full-width {
    max-width: 1070px;
  }
}

@media only screen and (max-width: 1400px) {
  .full-width {
    max-width: 1000px;
  }
}

@media only screen and (max-width: 1300px) {
  .full-width {
    max-width: 900px;
  }
}

@media only screen and (max-width: 1200px) {
  .full-width {
    max-width: 800px;
  }
}

@media only screen and (max-width: 1140px) {
  .full-width {
    max-width: 970px;
  }
}

@media only screen and (max-width: 1024px) {
  .full-width {
    max-width: 900px;
  }
}

@media only screen and (max-width: 914px) {
  .full-width {
    max-width: 800px;
  }
}

@media only screen and (max-width: 824px) {
  .full-width {
    max-width: 690px;
  }
}

@media only screen and (max-width: 576px) {
  .full-width {
    max-width: 420px;
  }
}

@media only screen and (max-width: 414px) {
  .full-width {
    max-width: 266px;
  }
}


@media only screen and (max-width: 380px) {
  .full-width {
    max-width: 240px;
  }
}
</style>